// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3yxbw","footer":"ModalUpdate_footer__1c6No"};